function str_z2h(str){
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){
      return String.fromCharCode(s.charCodeAt(0) - 65248)
  }).replace(/\u3000/g, " ")
}
export{
  str_z2h
}
